/* tslint:disable */




export class UserFilter {

	id: number;
	email: string;
	companyName: string;
	roleKey: string;
	dateCreated: string; // format yyyy-mm-dd
	bpo: boolean;
	clientUser: string;
	pageNumber: number;
	itemPerPage: number;
}
